import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AppRoot } from './AppRoot';
import { AppBoundary } from './AppBoundary';

// Global error handler for Firebase tenant mismatch
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.code === 'auth/tenant-id-mismatch') {
    console.error('❌ Tenant ID mismatch error caught globally');
    console.log('🔄 Clearing Firebase auth storage and reloading...');
    
    // Clear all Firebase-related localStorage
    Object.keys(localStorage).forEach(key => {
      if (key.includes('firebase')) {
        localStorage.removeItem(key);
      }
    });
    
    event.preventDefault();
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppBoundary>
      <AppRoot />
    </AppBoundary>
  </React.StrictMode>
);
